import { useMemo } from 'react'
import { LabFeatureFlags, LabRemoteConfigKeys } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { getVisibleLanguageOptions } from 'i18n/util/locale'

export function useVisibleLanguageOptions() {
  const languageSelectorFlag = useLabFeatureFlag(
    LabFeatureFlags.enableLanguageSelector,
  )
  const languagesRemoteConfig = useLabRemoteConfig(LabRemoteConfigKeys.languages)
  const languageOptions = useMemo(
    () => getVisibleLanguageOptions(languagesRemoteConfig),
    [languagesRemoteConfig],
  )
  const showLanguageSelector =
    Boolean(languageSelectorFlag?.enabled) && languageOptions.length > 1

  return { languageOptions, showLanguageSelector }
}
